import React from 'react';
import parse from 'html-react-parser';
import { Accordion } from 'react-bootstrap';
import { isImage, TSupplementalContent } from '@@config/wcs';
import { hashKey } from '@@utils/utils';

type TProvenanceAccordionProps = {
    tracrId?: string | undefined;
    provenanceName?: string | undefined;
    supplementalContent: TSupplementalContent[];
};

const ProvenanceAccordion: React.FC<TProvenanceAccordionProps> = ({
    tracrId = '',
    provenanceName = '',
    supplementalContent,
}) => {
    return (
        <>
            <p className='title'>More Information Listed in the Report</p>
            <Accordion className='mr-4'>
                {supplementalContent.map((content, index) => (
                    <Accordion.Item eventKey={`${index}`} key={hashKey(content.TITLE)}>
                        <Accordion.Header as='h5' className='w-full flex justify-between'>
                            <span>{parse(content.TITLE)}</span>
                            <span></span>
                        </Accordion.Header>

                        <Accordion.Body className='px-12 py-4'>
                            <dl className='flex items-baseline font-bold w-full'>
                                <dt>Tracr ID</dt>
                                <hr className='dotted-separator mx-2' />
                                <dd id='TRACR_ID'>{tracrId}</dd>
                            </dl>
                            {content?.['BODY_JSON'].map(item => {
                                return Object.entries(item).map(([key, value]) => {
                                    if (key === 'BODY' && Array.isArray(value)) {
                                        const [clickHereStatic = '', aboutTracr = '', disclosure = ''] = value;

                                        // TODO: Update the magnolia hosted redirect page to accept uri parameters
                                        const tracrUrl = `https://search.tracr.com/${tracrId}`;

                                        const clickHereDynamic = clickHereStatic.replace(
                                            /<a href=['"]#TRACR_URL['"]>/,
                                            `<a href="${tracrUrl}" target="_blank" class="external-link-blue">`
                                        );

                                        return (
                                            <>
                                                <dl className='flex items-baseline font-bold w-full'>
                                                    <dt>Country of Origin</dt>
                                                    <hr className='dotted-separator mx-2' />
                                                    <dd>{parse(provenanceName)}</dd>
                                                </dl>
                                                <p>{parse(clickHereDynamic)}</p>
                                                <p>{parse(aboutTracr)}</p>
                                                <p>{parse(disclosure)}</p>
                                            </>
                                        );
                                    }

                                    if (key === 'IMAGE' && isImage(value)) {
                                        return (
                                            <div className='flex justify-center' key={key}>
                                                <img
                                                    className='max-w-full h-auto mb-2'
                                                    src={value['SRC']}
                                                    alt={value['ALT_TEXT']}
                                                    style={{ maxWidth: 175, opacity: 0.65 }}
                                                />
                                            </div>
                                        );
                                    }

                                    return null;
                                });
                            })}
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </>
    );
};

export type { TProvenanceAccordionProps };
export default ProvenanceAccordion;
